const recentlyViewed = chunk => {
  const historyCount = 15;

  return (dispatch, getState) => {
    const splitChunk = chunk.split('.');
    const { learningPathJson } = getState().CourseState;
    let modLI, blockLI, mod, block;
    // chunk check stuff, homepage or not
    if (learningPathJson['li'] !== chunk) {
      modLI = splitChunk[0];
      blockLI = `${splitChunk[0]}.${splitChunk[1]}`;
      mod = learningPathJson.hasPart.find(m => m.li === modLI);
      block = mod.hasPart.find(b => b.li === blockLI);
    } else {
      modLI = chunk;
      blockLI = '';
      mod = learningPathJson;
      block = learningPathJson;
    }
    // get local storage object
    const storedRV = localStorage.getItem('netacad-RecentViews');
    // create recent view object
    let rvObj = {
      module: `${mod.name}`,
      block: `${block.name}`,
      li: `${blockLI}`,
      date: new Date()
    };
    // if we have something in local storage
    // get the object ready for a new recent view
    let newRV = storedRV ? JSON.parse(storedRV) : {};

    // if we don't have the current course in local storage
    // add it to the object
    if (!newRV[learningPathJson['@id']]) {
      newRV[learningPathJson['@id']] = [];
    }

    let indexOfRV = newRV[learningPathJson['@id']].findIndex(
      rv => rv.li === blockLI
    );

    // remove the entry if it is the same as the current page/block
    if (indexOfRV > -1) {
      newRV[learningPathJson['@id']].splice(indexOfRV, 1);
    }

    // add the entry
    newRV[learningPathJson['@id']].unshift(rvObj);

    // strip off older history
    newRV[learningPathJson['@id']] = newRV[learningPathJson['@id']].slice(
      0,
      historyCount
    );

    // set local storage
    localStorage.setItem('netacad-RecentViews', JSON.stringify(newRV));
    // tell Redux about it
    dispatch({
      type: 'UPDATE_RECENTLY_VIEWED'
    });
  };
};

export { recentlyViewed };
